module.exports = __webpack_public_path__ + "static/the-bottom-billion-b385931618ca4b302afb4253d1108b00.jpg";